export default __webpack_public_path__ + "static/media/mx.a1b1b953.svg";